import axios              from 'axios';
import {Config,jwtToken } from './configActions';
import moment             from 'moment';

export const FETCH_AUTHENTIC         = 'FETCH_AUTHENTIC';
export const SET_CURRENT_USER        = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_PERFIL = 'SET_CURRENT_USER_PERFIL';
export const SET_ERROR_ACTION        = 'SET_ERROR_ACTION';



Config();
var Authorization = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");


export function setCurrentUser(user,session,pontuacao){
       
	user.data = moment().format("DD/MM/YYYY");
	return {
			type: SET_CURRENT_USER,
			user,
			session,
			pontuacao
	}
}

export function checkSessao(){
	return dispatch =>{
		 axios.get(`/api/userCheck`,Authorization)
		.then((response)=>{
		
		}).catch((error)=>{
				dispatch(SetError(401));
		});
	}
}

export function SetEditarSenhaUser(senha,id){

	console.log(senha+' - '+id);
	// return dispatch =>{
	// 	return axios.post("/api/equipes/post/cadastrar", {
	// 		use_senha  : senha,
	// 		use_id : id
	// 	},Authorization);		
	// }

}

export function recuperarSenha(email){

	console.log(email);
	// return dispatch =>{
	// 	return axios.post("/api/equipes/post/cadastrar", {
	// 		use_senha  : senha,
	// 		use_id : id
	// 	},Authorization);		
	// }

}

export function logout(){

	return dispatch =>{

		localStorage.removeItem('jwtToken');
		localStorage.removeItem('session');
		localStorage.removeItem('pontuacao');
		localStorage.removeItem('novo_talento');
		 jwtToken(false);
		 dispatch(setCurrentUser({}));
		
	}

}

export function SetError(acao){


	 	return dispatch =>{

		    
		switch(acao) {

			// case 400:
				
			// 	alert('Login ou senha está incorreta.');
			// 	dispatch(logout());

			// break;

			case 401:
				
				alert('A sua sessão foi experida, favor faça o login novamente');
				window.location.assign(`${Config().raiz}/home`);
				dispatch(logout());

			break;

			case 500:
				
			 alert('Erro interno do servidor');

		// 	 const request = 'Erro interno do servidor';
		// 	 return {
		// 		type: SET_ERROR_ACTION,
		// 		payload : request
		// }


			 window.location.assign(`${Config().raiz}/home`);
				
			break;

			default:
	     	
			//dispatch(logout());
			break;
			
		}

	}
}

export function authentic(data){

   const request =  axios.post('/auth/login', {
                    use_login : data.login,
                    password  : data.senha
                });
    
    return{
        type    : FETCH_AUTHENTIC,
        payload : request

    };   

	
}

export function SetUploadFotoPerfil(file,use_id) {
	
	const formData = new FormData();
	formData.append('use_foto', file);
	formData.append('use_id', use_id);
	const request = axios.post('/api/usuarios/perfil/upload', formData,Authorization);

	return{
		type    : SET_CURRENT_USER_PERFIL,
		payload : request
	};  

}


// WEBPACK FOOTER //
// ./src/actions/authenticActions.js